// @flow
import tabs$ from '@containers/Apparel/Designs/Request/Tabs';

import { List, Map } from 'immutable';
import { Reducer }   from '../../Reducer';

import {
    simpleOnGetFail,
    simpleOnGetRequest,
    simpleOnGetSuccess,
    simpleOnItemCreateDone,
    simpleOnItemCreateFail,
    simpleOnItemCreateRequest,
    simpleOnItemCreateSuccess,
    simpleOnItemLoadFail,
    simpleOnItemLoadRequest,
    simpleOnItemLoadSuccess,
    simpleOnItemUpdateDone,
    simpleOnItemUpdateFail,
    simpleOnItemUpdateRequest,
    simpleOnItemUpdateSuccess
}                 from '../../utils';
import * as TYPES from './types';

const DEFAULT_STATE = Map({
    ...Reducer.DEFAULT_STATE,
    DesignExamples: Map({
        ...Reducer.DEFAULT_STATE
    }),
    Request: Map(tabs$.all()
        .reduce(( state, { key, defaultState } ) => {
            let value = defaultState || {};

            if ( typeof value === 'object' ) {
                value = Array.isArray(value) ? List(value) : Map(value);
            }

            return ( {
                ...state,
                [ key ]: value
            } );
        }, {}))
});

export default class DesignsReducer extends Reducer {
    NAME = 'Designs';

    alias = {
        [ TYPES.DESIGNS_GET_REQUEST ]: 'onGetRequest',
        [ TYPES.DESIGNS_GET_SUCCESS ]: 'onGetSuccess',
        [ TYPES.DESIGNS_GET_FAIL ]:    'onGetFailure',

        [ TYPES.DESIGN_CREATE_REQUEST ]: 'onItemCreateRequest',
        [ TYPES.DESIGN_CREATE_SUCCESS ]: 'onItemCreateSuccess',
        [ TYPES.DESIGN_CREATE_FAIL ]:    'onItemCreateFailure',
        [ TYPES.DESIGN_CREATE_DONE ]:    'onItemCreateDone',

        [ TYPES.DESIGN_LOAD_REQUEST ]: 'onItemLoadRequest',
        [ TYPES.DESIGN_LOAD_SUCCESS ]: 'onItemLoadSuccess',
        [ TYPES.DESIGN_LOAD_FAIL ]:    'onItemLoadFailure',

        [ TYPES.DESIGN_UPDATE_REQUEST ]: 'onItemUpdateRequest',
        [ TYPES.DESIGN_UPDATE_SUCCESS ]: 'onItemUpdateSuccess',
        [ TYPES.DESIGN_UPDATE_FAIL ]:    'onItemUpdateFailure',
        [ TYPES.DESIGN_UPDATE_DONE ]:    'onItemUpdateDone',

        [ TYPES.DESIGN_REQUEST_STEP_COMMIT ]: 'onRequestCommitStep',
        [ TYPES.DESIGN_REQUEST_RESET ]:       'onRequestReset',

        [ TYPES.DESIGN_EXAMPLES_GET_REQUEST ]: 'onDesignExampleGetRequest',
        [ TYPES.DESIGN_EXAMPLES_GET_SUCCESS ]: 'onDesignExampleGetSuccess',
        [ TYPES.DESIGN_EXAMPLES_GET_FAIL ]:    'onDesignExampleGetFailure',

        [ TYPES.DESIGN_EXAMPLE_CREATE_REQUEST ]: 'onDesignExampleItemCreateRequest',
        [ TYPES.DESIGN_EXAMPLE_CREATE_SUCCESS ]: 'onDesignExampleItemCreateSuccess',
        [ TYPES.DESIGN_EXAMPLE_CREATE_FAIL ]:    'onDesignExampleItemCreateFailure',
        [ TYPES.DESIGN_EXAMPLE_CREATE_DONE ]:    'onDesignExampleItemCreateDone',

        [ TYPES.DESIGN_EXAMPLE_LOAD_REQUEST ]: 'onDesignExampleItemLoadRequest',
        [ TYPES.DESIGN_EXAMPLE_LOAD_SUCCESS ]: 'onDesignExampleItemLoadSuccess',
        [ TYPES.DESIGN_EXAMPLE_LOAD_FAIL ]:    'onDesignExampleItemLoadFailure',

        [ TYPES.DESIGN_EXAMPLE_UPDATE_REQUEST ]: 'onDesignExampleItemUpdateRequest',
        [ TYPES.DESIGN_EXAMPLE_UPDATE_SUCCESS ]: 'onDesignExampleItemUpdateSuccess',
        [ TYPES.DESIGN_EXAMPLE_UPDATE_FAIL ]:    'onDesignExampleItemUpdateFailure',
        [ TYPES.DESIGN_EXAMPLE_UPDATE_DONE ]:    'onDesignExampleItemUpdateDone'
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetRequest = simpleOnGetRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetSuccess = simpleOnGetSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetFailure = simpleOnGetFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadRequest = simpleOnItemLoadRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadSuccess = simpleOnItemLoadSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemLoadFailure = simpleOnItemLoadFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateRequest = simpleOnItemCreateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateSuccess = simpleOnItemCreateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateFailure = simpleOnItemCreateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemCreateDone = simpleOnItemCreateDone(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateRequest = simpleOnItemUpdateRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateSuccess = simpleOnItemUpdateSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateFailure = simpleOnItemUpdateFail(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onItemUpdateDone = simpleOnItemUpdateDone(DEFAULT_STATE);

    /**
     * Commit request form steps
     * @param state$
     * @param payload
     * @returns {this}
     */
    onRequestCommitStep ( state$ = DEFAULT_STATE, { payload } ) {
        const { state, tab } = payload;
        const immutableState = Map(state || {});
        const stepState = state$.getIn([
            'Request',
            tab.key
        ]) || Map({});
        return state$.setIn([
            'Request',
            tab.key
        ], stepState.merge(immutableState));
    }

    /**
     * Reset request data
     * @param state$
     * @return {this}
     */
    onRequestReset ( state$ = DEFAULT_STATE ) {
        return state$.set('Request', DEFAULT_STATE.get('Request'));
    }

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignExampleGetRequest = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnGetRequest(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignExampleGetSuccess = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnGetSuccess(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignExampleGetFailure = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnGetFail(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemLoadRequest = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemLoadRequest(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemLoadSuccess = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemLoadSuccess(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemLoadFailure = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemLoadFail(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemCreateRequest = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemCreateRequest(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemCreateSuccess = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemCreateSuccess(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemCreateFailure = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemCreateFail(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemCreateDone = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemCreateDone(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemUpdateRequest = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemUpdateRequest(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemUpdateSuccess = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemUpdateSuccess(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemUpdateFailure = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemUpdateFail(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onDesignItemUpdateDone = ( state = DEFAULT_STATE, action ) => (
        state.set('DesignExample', simpleOnItemUpdateDone(state.get('DesignExample'))(state.get('DesignExample'), action))
    );

    onDefault ( state$ = DEFAULT_STATE ) {
        return state$;
    }
}
